import React from "react"

export const iconResolver = (icon: any) => {
	return React.createElement(icon, { size: 18 })
}